import muster from '@dbk-legacy/muster';
//import $ from 'npm-zepto';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { DOCSIGN_API_ERROR_CODES, DOCSIGN_CONSTANTS } from '../../../constants';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH, ERROR } from './docsign-muster-constants';
import PdfDownload from '../../../utils/attachment-download';

export default () => {
  return muster()
    .path('acceptsign.getAcceptView', {
      call: async ({ req }, { get, set }) => {
        const documentId = req.args[0];
        const documentName = req.args[1];
        const inputs = `${documentId}#@#`;
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));

        await set('acceptsign.documentName', documentName);
        await set('app.user.cacheId', Date.now());

        // Bypassing Falcor implementation for dsAcceptView API call

        // var [envitronmentUrl, apiversion, defaultEnvironment] = await getValues(
        //   get([
        //     'settings.currentEnvironment.remoteUrl',
        //     'app.config.apiverion',
        //     'settings.defaultEnvironment'
        //   ])
        // );
        // const [authHeader] = await getValues(get(['auth.authHeader']));
        // const [userId] = await getValues(get(['auth.userId']));
        // let docUrl;

        // if (defaultEnvironment === "local" || defaultEnvironment === "static") {
        //   // Testing APAC DEV
        //   docUrl = "https://pwpbod01.sg.db.com:8243/digisign/1.0/dsAcceptView"
        // } else {
        //   docUrl = envitronmentUrl + '/digisign/' + apiversion + '/dsAcceptView';
        // }

        // var body = {
        //   userId: userId,
        //   branchCode: '1',
        //   dwoDocId: documentId
        // }

        // try {
        //   $.ajax({
        //     type: 'POST',
        //     url: docUrl,
        //     headers: {
        //       'Accept': 'application/json',
        //       'Content-Type': 'application/json',
        //       'Authorization-Token': authHeader,
        //       // Enable for LOCAL Testing
        //       // 'Authorization': 'Bearer 301df1cb335808eb59f4461c21f6a021',
        //     },
        //     dataType: 'json',
        //     contentType: 'application/json',
        //     data: JSON.stringify(body),
        //     success: async function (result) {
        //       isValidJsonString(result).then(async (acceptViewResponse) => {
        //         if (acceptViewResponse) {
        //           if (acceptViewResponse.$type || acceptViewResponse.messageType === ERROR) {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //             return;
        //           }
        //           if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT ||
        //             acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             let docName = documentName ? documentName : 'document';

        //             PdfDownload(docName, acceptViewResponse.data.base64data);

        //           } else if (
        //             acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT ||
        //             acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             await set('acceptsign.acceptViewResponseError', messages['app.docsign.nodata.response']);

        //           } else if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_ERROR_INT ||
        //             acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_ERROR) {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);

        //           } else if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.ACCEPT_JSON_EXCEPTION_INT || acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.ACCEPT_JSON_EXCEPTION) {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //           } else {
        //             await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //             await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //           }

        //         } else {
        //           await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //           await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //         }
        //       }).catch(async (acceptViewResponse) => {
        //         await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //         await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //       });
        //     }.bind(this),
        //     error: async function (request, status, acceptViewResponse) {
        //       await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //       await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        //     }.bind(this)
        //   });
        // } catch (acceptViewResponse) {
        //   await set('acceptsign.acceptViewResponse', acceptViewResponse);
        //   await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        // }

        // Going through Falcor implementation for dsAcceptView API call

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getAcceptView["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (acceptViewResponse) => {
          if (acceptViewResponse) {
            if (acceptViewResponse.$type || acceptViewResponse.messageType === ERROR) {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
              return;
            }
            if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT ||
              acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              let docName = documentName ? documentName : 'document';

              PdfDownload(docName, acceptViewResponse.data.base64data);

            } else if (
              acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT ||
              acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              await set('acceptsign.acceptViewResponseError', messages['app.docsign.nodata.response']);

            } else if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_ERROR_INT ||
              acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.DMS_UPLOAD_ERROR) {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);

            } else if (acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.ACCEPT_JSON_EXCEPTION_INT || acceptViewResponse.returnCode === DOCSIGN_API_ERROR_CODES.ACCEPT_JSON_EXCEPTION) {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
            } else {
              await set('acceptsign.acceptViewResponse', acceptViewResponse);
              await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
            }

          } else {
            await set('acceptsign.acceptViewResponse', acceptViewResponse);
            await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
          }
        }).catch(async (acceptViewResponse) => {
          await set('acceptsign.acceptViewResponse', acceptViewResponse);
          await set('acceptsign.acceptViewResponseError', messages['app.digisign.error.tryagain']);
        });
      }
    })
    .path('acceptsign.getActionAccept', {
      call: async ({ req }, { get, set, call }) => {
        await set('acceptsign.showLoadingForConfirmModal', true);
        const txId = req.args[0];
        const action = req.args[1];
        const comment = req.args[2];
        let inputs;
        if (comment) {
          inputs = `${txId}#@#${action}#@#${comment}`;
        } else {
          inputs = `${txId}#@#${action}`;
        }
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`${DOCSIGN_PATH}.getActionAccept["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (actionAcceptResponse) => {
          await set('acceptsign.showLoadingForConfirmModal', false);
          if (actionAcceptResponse) {
            if (actionAcceptResponse.$type || actionAcceptResponse.messageType === ERROR) {
              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);
              const [numOfActionCalls] = await getValues(get('acceptsign.numOfActionCalls'));
              await set('acceptsign.numOfActionCalls', numOfActionCalls + 1);
              return;
            }
            if (actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT ||
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              if (actionAcceptResponse.data &&
                actionAcceptResponse.data.status.toLowerCase() === DOCSIGN_CONSTANTS.SUCCESS_RESPONSE) {
                await set('docsign.showAcceptSignModal', false);
                await set('acceptsign.actionAcceptResponseError', '');
                if (action === DOCSIGN_CONSTANTS.ACCEPT) {
                  await call('rsa.changePage', '/docsign/accept-sign-success');
                }
              }
              await call('notifications.getUserNotifications');
            } else if (
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.REJECT_COMMENT_REQ_INT ||
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.REJECT_COMMENT_REQ) {
              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);

            } else if (
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT ||
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);

            } else if (
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.TABLE_UPDATE_FAILED_INT ||
              actionAcceptResponse.returnCode === DOCSIGN_API_ERROR_CODES.TABLE_UPDATE_FAILED) {

              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);

            }

            else {
              await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
              await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);
            }

          } else {
            await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
            await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);
          }
          const [numOfActionCalls] = await getValues(get('acceptsign.numOfActionCalls'));
          await set('acceptsign.numOfActionCalls', numOfActionCalls + 1);
        }).catch(async (actionAcceptResponse) => {
          await set('acceptsign.showLoadingForConfirmModal', false);
          await set('acceptsign.actionAcceptResponse', actionAcceptResponse);
          await set('acceptsign.actionAcceptResponseError', messages['app.digisign.error.tryagain']);
        });
      }
    })
    .path('acceptsign.acceptViewResponse', variable(''))
    .path('acceptsign.actionAcceptResponse', variable(false))
    .path('acceptsign.errorMsg', variable(''))
    .path('acceptsign.acceptViewResponseError', variable(''))
    .path('acceptsign.actionAcceptResponseError', variable(''))
    .path('acceptsign.actionAcceptResponseSuccess', variable(false))
    .path('acceptsign.documentName', variable(''))
    .path('acceptsign.actionRejectModal', variable(false))
    .path('acceptsign.actionRejectResponseSuccess', variable(false))
    .path('acceptsign.showLoadingForConfirmModal', variable(false))
    .path('acceptsign.numOfActionCalls', variable(0));
};